import { render, staticRenderFns } from "./FlightsAdmin.vue?vue&type=template&id=5b6673c0&"
import script from "./FlightsAdmin.vue?vue&type=script&lang=js&"
export * from "./FlightsAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports